export default "__VITE_ASSET__DVPxG_Xk__"